import React, { Component } from 'react';
import { fetchJson } from '@/util/helpers/ajax-helpers';

//
// match up with EnumSearchType.java
//
const TABLES = 'tables';
const VIEWS = 'views';
const COLUMNS = 'columns';
const QUERIES = 'queries';
const EMPTY = 'empty';

//
// https://github.com/twitter/typeahead.js/blob/master/doc/jquery_typeahead.md#options
//
// Using this fork (https://github.com/corejavascript/typeahead.js), as twitter version is not maintained
//
class SearchBox extends Component {
  static clearSearchBox() {
    $('#datasource-search').val('').trigger('input');
  }

  static open() {
    $('#datasource-search').typeahead('open');
  }

  componentDidMount() {
    const searchBox = $(this._input);
    this._callbacks = {};

    setTimeout(() => {
      if (this._input) {
        this._input.focus();
      }
    }, 500);

    const matcher = (type) => (q, syncCb, asyncCb) => {
      if (q === '___') {
        return;
      }
      if (this._timeout) {
        clearTimeout(this._timeout);
      }
      if (!this._callbacks[q]) {
        this._callbacks[q] = {};
      }
      this._callbacks[q][type] = asyncCb;

      this._timeout = setTimeout(() => {
        // request auto-complete suggestions
        fetchJson(`/search/?query=${encodeURI(q)}`)
          .then((json) => {
            [TABLES, VIEWS, COLUMNS, QUERIES].forEach((t) => {
              const results = json
                .filter((s) => s._type === t)
                .map((s) => s._suggestion);
              this._callbacks[q][t](results);
            });
            if (json.length === 0) {
              this._callbacks[q][EMPTY](['']);
            }
          })
          .catch((error) => {
            window.console.error(`search failed:${error}`);
          });
      }, 300);
    };
    const renderSuggestion = (suggestion) => {
      const words = searchBox
        .typeahead('val')
        .split(' ')
        .filter((s) => s.length > 0)
        .sort((a, b) => a.length - b.length);
      let result = '';
      OUTER: for (let i = 0; i < suggestion.length; ++i) {
        for (const word of words) {
          if (
            suggestion.substring(i, i + word.length).toLowerCase() ===
            word.toLowerCase()
          ) {
            // make bold
            result += `<strong>${word}</strong>`;
            i += word.length - 1;
            continue OUTER;
          }
        }
        result += suggestion[i];
      }
      return `<div>${result}</div>`;
    };

    searchBox.typeahead(
      {
        hint: true,
        highlight: false, // disable, as we do it ourselves
        minLength: 1,
      },
      {
        limit: 5,
        source: matcher(TABLES),
        templates: {
          header: '<div class="tt-header">Tables</div>',
          suggestion: renderSuggestion,
        },
      },
      {
        limit: 5,
        source: matcher(VIEWS),
        templates: {
          header: '<div class="tt-header">Views</div>',
          suggestion: renderSuggestion,
        },
      },
      {
        limit: 5,
        source: matcher(COLUMNS),
        templates: {
          header: '<div class="tt-header">Columns</div>',
          suggestion: renderSuggestion,
        },
      },
      {
        limit: 10,
        source: matcher(QUERIES),
        templates: {
          header: '<div class="tt-header">Suggested queries</div>',
          suggestion: renderSuggestion,
        },
      },
      {
        limit: 1,
        source: matcher(EMPTY),
        templates: {
          header: '<div class="tt-header">No matches found</div>',
        },
      },
    );
    searchBox.bind('typeahead:select', () => {
      const val = $(this._input).typeahead('val');
      // execute selected query
      this._onEnterPressed(val);
      // check if they've selected a column suggestion or an operator
      if (val.indexOf(' :: ') !== -1 || val === 'count' || val === 'recent') {
        // re-open  suggestions dialog after selection (TODO: unless value is executable)
        setTimeout(() => {
          $(this._input)
            .val('___')
            .trigger('input')
            .val(`${val} `) // add space to end to give suggestions
            .trigger('input');
        }, 1);
      }
    });
  }

  render() {
    const { onEnterPressed } = this.props;
    this._onEnterPressed = onEnterPressed;
    const keyPress = (e) => {
      if (e.charCode === 13) {
        const searchBox = $(this._input);
        const value = searchBox.typeahead('val');
        searchBox.typeahead('close');
        onEnterPressed(value);
      }
    };
    return (
      <div className="input-group search-box">
        <input
          id="datasource-search"
          onKeyPress={keyPress}
          type="text"
          className="form-control"
          placeholder="Search views, columns or tables"
          name="srch-term"
          ref={(input) => (this._input = input)}
        />
      </div>
    );
  }
}

export default SearchBox;
